import {
  Field,
  Form,
  type FormikErrors,
  type FormikTouched,
  type FormikValues,
} from 'formik';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { apiRoutes } from '../../constants/api-routes.constants';
import { LOGIN_CONSTANTS } from '../../constants/login.constants';
import ButtonComponent from '../UI/Button/Button.component';

const renderValidationError = (
  errors: FormikErrors<FormikValues>,
  touched: FormikTouched<FormikValues>,
  field: string,
) =>
  errors[field] && touched[field] ? (
    <p className="custom-invalid-feedback">
      {errors[field] as React.ReactNode}
    </p>
  ) : null;

export const LoginFormRender = (props: {
  errors: FormikErrors<FormikValues>;
  touched: FormikTouched<FormikValues>;
  valid: boolean;
  loading?: boolean;
}) => {
  const { errors, touched, valid, loading } = props;
  const lcPassword = LOGIN_CONSTANTS.PASSWORD.toLowerCase();
  const lcUsername = LOGIN_CONSTANTS.USERNAME.toLowerCase();

  return (
    <Form className="LoginUser__Form needs-validation">
      <div className="LoginUser__UserInput">
        <Field
          className={`LoginUser__FormInput form-control ${
            errors.username && touched.username ? 'is-invalid' : ''
          }`}
          id={lcUsername}
          name={lcUsername}
          placeholder={LOGIN_CONSTANTS.USERNAME}
          type="text"
        />
        {renderValidationError(errors, touched, 'username')}
      </div>
      <div className="LoginUser__UserInput">
        <Field
          className={`LoginUser__FormInput form-control ${
            errors.password && touched.password ? 'is-invalid' : ''
          }`}
          id={lcPassword}
          name={lcPassword}
          placeholder={LOGIN_CONSTANTS.PASSWORD}
          type={lcPassword}
        />
        {errors.password && touched.password ? (
          <p className="custom-invalid-feedback">
            {errors.password as React.ReactNode}
          </p>
        ) : null}
      </div>
      <ButtonComponent
        className="LOGIN__BUTTON"
        variant="primary"
        disabled={!valid || loading}
        type="submit"
        loading={loading}
      >
        {loading ? 'Logging in...' : LOGIN_CONSTANTS.LOGIN}
      </ButtonComponent>
      <br />
      <Link className={'HYPERLINK'} to={apiRoutes.SIGNUP}>
        {LOGIN_CONSTANTS.SIGN_UP}
      </Link>
    </Form>
  );
};
